import { useState } from "react";
import { BookText, ChevronDown, ChevronUp } from "lucide-react";
import PC from "./../../assets/Guideline/PCguideline.png";
import mobile from "./../../assets/Guideline/mobileguideline.png";

function TracingImageGuideline() {
  const [openSection, setOpenSection] = useState(null); // "pc" | "mobile" | null

  const toggleSection = (section) => {
    setOpenSection((prev) => (prev === section ? null : section));
  };

  return (
    <div className="space-y-4 pt-2">
      {/* Header */}
      <div className="flex items-center gap-2">
        <BookText className="w-5 h-5 " />
        <div className="font-bold text-base ">
          리뷰배너 등록방법
        </div>
      </div>
      <hr />

      {/* PC Section */}
      <div>
        <div
          className="pt-2 flex justify-between items-center border-b pb-1 cursor-pointer transition-colors"
          onClick={() => toggleSection("pc")}
        >
          <p
            className={`pb-2 font-semibold transition-colors ${
              openSection === "pc" ? "text-[#46B6D0]" : "text-black"
            }`}
          >
            PC 등록방법
          </p>
          {openSection === "pc" ? (
            <ChevronUp className="w-5 h-5 text-[#46B6D0] transition-colors" />
          ) : (
            <ChevronDown className="w-5 h-5 text-black transition-colors" />
          )}
        </div>
        {openSection === "pc" && (
          <img
            src={PC}
            alt="PC 가이드"
            className="mt-2 rounded shadow border"
          />
        )}
      </div>

      {/* Mobile Section */}
      <div>
        <div
          className="flex justify-between items-center border-b pb-1 cursor-pointer transition-colors"
          onClick={() => toggleSection("mobile")}
        >
          <p
            className={`pb-2 font-semibold transition-colors ${
              openSection === "mobile" ? "text-[#46B6D0]" : "text-black"
            }`}
          >
            모바일 등록방법
          </p>
          {openSection === "mobile" ? (
            <ChevronUp className="w-5 h-5 text-[#46B6D0] transition-colors" />
          ) : (
            <ChevronDown className="w-5 h-5 text-black transition-colors" />
          )}
        </div>
        {openSection === "mobile" && (
          <img
            src={mobile}
            alt="모바일 가이드"
            className="mt-2 rounded shadow border"
          />
        )}
      </div>
    </div>
  );
}

export default TracingImageGuideline;
